/**
 * Created by Ning Jiang on 2025-01-08.
 */

import {Emitter} from "pixi-particles";
import {ElGordosRevenge} from "../../ElGordosRevenge";
import {ParticlesManager} from "../../../core/particles/ParticlesManager";
import {TweenLite} from "gsap";

export class WinCapParticles extends PIXI.Container {

    private _boostConfig = {
        "alpha" : {
            "start" : 1,
            "end" : 0.11
        },
        "scale" : {
            "start" : 0.5,
            "end" : 1,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#f0ab7d",
            "end" : "#f0ab7d"
        },
        "speed" : {
            "start" : 150,
            "end" : 160,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 20,
            "y" : -40
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 180,
            "max" : 330
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 150,
            "max" : 250
        },
        "lifetime" : {
            "min" : 3.5,
            "max" : 6
        },
        "blendMode" : "normal",
        "frequency" : 0.015,
        "emitterLifetime" : 1,
        "maxParticles" : 100,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "circle",
        "spawnCircle" : {
            "x" : 0,
            "y" : 0,
            "r" : 200
        }
    };
    private _config = {
        "alpha" : {
            "start" : 0.8,
            "end" : 0.1
        },
        "scale" : {
            "start" : 0.5,
            "end" : 1,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 150,
            "end" : 100,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 0,
            "y" : -20
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 270,
            "max" : 330
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 50,
            "max" : 150
        },
        "lifetime" : {
            "min" : 3.5,
            "max" : 4
        },
        "blendMode" : "normal",
        "frequency" : 0.06,
        "emitterLifetime" : -1,
        "maxParticles" : 100,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -350,
            "y" : 200,
            "w" : 700,
            "h" : 100
        }
    };

    private _emitter:Emitter | null;

    constructor() {
        super();
    }

    public play():void {
        this._emitter = new Emitter(this, [
            ElGordosRevenge.assetLoader.getTextures("particles/spark_1")[0],
            ElGordosRevenge.assetLoader.getTextures("particles/spark_2")[0],
            ElGordosRevenge.assetLoader.getTextures("particles/spark_3")[0],
            ElGordosRevenge.assetLoader.getTextures("particles/spark_4")[0]
        ], this._config);
        ParticlesManager.addEmitter(this._emitter);

        const boostEmitter = new Emitter(this, [
            ElGordosRevenge.assetLoader.getTextures("particles/spark_1")[0],
            ElGordosRevenge.assetLoader.getTextures("particles/spark_2")[0],
            ElGordosRevenge.assetLoader.getTextures("particles/spark_3")[0],
            ElGordosRevenge.assetLoader.getTextures("particles/spark_4")[0]
        ], this._boostConfig);
        ParticlesManager.addEmitter(boostEmitter);
        TweenLite.to(this, boostEmitter.emitterLifetime, {
            onComplete : () => {
                ParticlesManager.queueRemoveEmitter(boostEmitter);
            }
        });
    }

    public stop():void {
        if(this._emitter) {
            ParticlesManager.queueRemoveEmitter(this._emitter);
        }
        this._emitter = null;
    }
}